

type ScheduleAlertsProps = {
  showExpired: boolean;
  needsAllDates?: boolean;
  allDatesCount?: number;
  activeDatesCount?: number;
  missingDatesCount?: number;
  missingDates?: string[];
  fullyBookedDates?: string[];
};

export function ScheduleAlerts({
  showExpired,
  needsAllDates,
  fullyBookedDates = [],
}: ScheduleAlertsProps) {
  const showFullyBooked = fullyBookedDates.length > 0;
  if (!showExpired && !needsAllDates && !showFullyBooked) return null;

  return (
    <div className="flex flex-col gap-2.5">
      {showExpired ? (
        <div
          className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-left text-sm text-amber-950"
          role="status"
        >
          <p className="m-0 font-semibold">Slot reservation expired</p>
          <p className="mt-1 mb-0 text-xs leading-relaxed text-amber-900/90">
            Your previous time slots were released. Campaign details are still
            saved — please select time slots again to continue.
          </p>
        </div>
      ) : null}


    </div>
  );
}

